import React, { Fragment, type FunctionComponent, useRef } from 'react'
import { useReCaptchaRenderer } from '@retailer-platform/shared-common'
import { css } from '@emotion/react'
import { type UseRenderReCaptchaProps } from '@retailer-platform/shared-common'
import { type DashMessages } from 'intl/intl.types'
import { ErrorMessage } from 'gin-and-tonic/common/error-message/ErrorMessage'
import { spacing } from 'gin-and-tonic/foundation/spacing'
import clientEnv from 'utils/global/clientEnv'

const reCaptchaWrapperStyles = css({
  padding: spacing.X8,
  height: spacing.X92,
})

const reCaptchaPlaceholderStyles = css({
  height: spacing.X92,
})

export interface ReCaptchaCheckBoxProps
  extends Pick<UseRenderReCaptchaProps, 'action' | 'setResetHandler' | 'onLoad' | 'onChange'> {
  errorMessageId: DashMessages
}

export const ReCaptchaCheckBox: FunctionComponent<ReCaptchaCheckBoxProps> = ({
  errorMessageId,
  ...rest
}) => {
  const ref = useRef<HTMLDivElement>(null)

  useReCaptchaRenderer({
    ...rest,
    ref,
    sitekey: clientEnv.PUBLIC_CLIENT_GOOGLE_RECAPTCHA_SITE_KEY,
  })

  return (
    <Fragment>
      <div css={reCaptchaWrapperStyles}>
        <div data-testid={rest['data-testid']} ref={ref} css={reCaptchaPlaceholderStyles} />
      </div>
      <ErrorMessage collapse={false} messageId={errorMessageId} />
    </Fragment>
  )
}
